module.exports = __webpack_public_path__ + "img/homepage_banner.6c6de2e8.png";